export default "__VITE_ASSET__BfguIKrm__"